import * as types from '../constants/actionTypes';

export function getTimeSpentOnProject({projectID, status, data} = {}) {
    return { type: types.GET_TIME_SPENT_ON_PROJECT, projectID, status, data };
}
export function getTimeSpentOnProjectByUser({projectID, userID, status, data} = {}) {
    return { type: types.GET_TIME_SPENT_ON_PROJECT_BY_USER, projectID, userID, status, data };
}
export function getTimeSpentOnTask({taskID, status, data} = {}) {
    return { type: types.GET_TIME_SPENT_ON_TASK, taskID, status, data };
}
export function getTimeSpentOnTaskByUser({taskID, userID, status, data} = {}) {
    return { type: types.GET_TIME_SPENT_ON_TASK_BY_USER, taskID, userID, status, data };
}



/** WEBPACK FOOTER **
 ** ./src/app/constants/timeActions.js
 **/